import Vue from 'vue';
import Router from 'vue-router';
import paths from './paths';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

Vue.use(Router);
const router =  new Router({
  base: '/',
  mode: 'hash',
  linkActiveClass: 'active',
  routes: paths
});
// router gards
router.beforeEach((to, from, next) => {
  NProgress.start();

  //verificamos en todas las rutas que este seteado el apiUrl, si no redirigimos a 403
  // if(to.path != '/login' && to.path != '/403' && !localStorage.getItem('apiUrl') ){
  //   NProgress.done();
  //   router.replace('/403');
  // }

  next();
});

router.afterEach((to, from) => {
  NProgress.done();
});

export default router;
